import React from 'react';
import { FaClipboardList } from 'react-icons/fa';
import '../CRM.css';

const COLOR_MAP = {
  'IndiaMART': '#F97316',
  'Manual': '#6366F1',
  'Website': '#0EA5E9',
  'Referral': '#10B981',
  'Other': '#94A3B8',
};

export const ActivityTimeline = ({ activities = [] }) => {
  if (!activities.length) {
    return (
      <div className="crm-empty">
        <div className="crm-empty-icon"><FaClipboardList aria-hidden="true" /></div>
        <div className="crm-empty-title">No activities yet</div>
        <div className="crm-empty-desc">Activities will appear here as you work on this lead.</div>
      </div>
    );
  }
  return (
    <div className="crm-timeline">
      {activities.map((a, i) => (
        <div className="crm-timeline-item" key={a.id || i}>
          <div className="crm-timeline-dot" style={{ background: COLOR_MAP[a.type] || '#6366F1' }} />
          <div className="crm-timeline-date">
            {a.date || (a.createdAt ? new Date(a.createdAt).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '')}
          </div>
          <div className="crm-timeline-title">{a.title}</div>
          {(a.description || a.desc) && <div className="crm-timeline-desc">{a.description || a.desc}</div>}
          {a.actor && <div className="crm-timeline-desc" style={{ fontSize: '0.74rem', opacity: 0.75 }}>by {a.actor}</div>}
        </div>
      ))}
    </div>
  );
};

export default ActivityTimeline;
